import { call, put, takeEvery } from 'redux-saga/effects';
import { getJSON } from '../../shared/util';

function* getProducts({ payload }) {
    const products = yield call(getJSON, `/api/products?upcs=${payload.upcs}`);

    yield put({
        type: 'product-carousel:update',
        payload: {
            [payload.name]: products.data,
        },
    });
}

export function* root() {
    yield takeEvery('product-carousel:get-products', getProducts);
}
